import { CustomResponeData } from 'axios'
import { baseURL } from './const'
import yoda from '../3rd-lib/yoda'
import login from '../login'
import { reportError } from '../owl'
import { I_RESPONSE } from './types'

const DEFAULT_CONFIG = {
  needToasted: true,
  needLogin: false,
}

export default function processResponse<T>(response: I_RESPONSE<T>): any {
  // console.log('resp', 2)
  if (response.data.status === 0) {
    return response.data.data
  }
  if (
    response.config.url &&
    (response.config.url.indexOf(baseURL) !== -1 || response.config.url.indexOf('https://appmock.sankuai.com') !== -1)
  ) {
    // mtsi
    // {"msg":"您的网络好像不太给力，请稍后再试","code":406,"customData":{"verifyPageUrl":"https://verify.meituan.com/v2/app/general_page?action=spiderindefence&requestCode=c3180fc244e24d7ba10c502c919c1c9b&platform=1000&adaptor=auto&succCallbackUrl=https://optimus-mtsi.meituan.com/optimus/verifyResult","imageUrl":"https://verify.meituan.com/v2/captcha?action=spiderindefence&request_code=c3180fc244e24d7ba10c502c919c1c9b","requestCode":"c3180fc244e24d7ba10c502c919c1c9b","verifyUrl":"https://optimus-mtsi.meituan.com/optimus/verify?request_code=c3180fc244e24d7ba10c502c919c1c9b"}}
    if (!response.data.status && response.data.code) {
      response.data.status = response.data.code
      response.data.message = response.data.msg
      if (response.data.customData) {
        const { requestCode } = response.data.customData
        response.data.requestCode = requestCode
      }
    }
    if (response.data.status !== 0 && !response.data.message) {
      // @ts-expect-error data 里面包含错误信息
      if (response.data.data && response.data.data.msg) {
        // @ts-expect-error data 里面包含错误信息
        response.data.message = response.data.data.msg
      }
    }
    // 错误码：
    if ([401].indexOf(response.data.status || 0) !== -1) {
      response.data.needLogin = true
    }
  }
  return Promise.reject(response.data)
}

export function isResponseError(error: any): error is CustomResponeData<{}> {
  if (error.status && error.status !== 0 && error.message) {
    return true
  }
  return false
}

export async function errorHandler(
  err: unknown,
  _config: {
    needToasted?: boolean
    needLogin?: boolean
    defaultErrorMessage?: string
  },
) {
  const config = { ...DEFAULT_CONFIG, ..._config }
  console.warn('@errorHandler', err, config)
  const { needToasted, needLogin, defaultErrorMessage } = config
  if (isResponseError(err)) {
    if (err.requestCode) {
      return yoda(err.requestCode)
    }
    if (err.needLogin) {
      if (needLogin) {
        login()
      }
    } else if (err.needOauth) {
      // do nothing
    } else if (err.status && err.message) {
      if (needToasted) {
        window.$toasted.show(err.message || defaultErrorMessage)
      }
    }
  } else {
    // 通常为 js 异常
    reportError({
      name: err,
      msg: err,
    })
  }
}
